import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import Checkout from 'src/features/Checkout';
// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

const CheckoutPage = () => {
  // const location = useLocation();

  // useEffect(() => {
  //   window.addEventListener('beforeunload', alertUser);
  //   return () => {
  //     window.removeEventListener('beforeunload', alertUser);
  //   };
  // }, []);
  // const alertUser = (e: ExpectedAny) => {
  //   e.preventDefault();
  //   e.returnValue = '';
  // };

  // useEffect(() => {
  //   // execute on location change

  //   return () => {
  //     console.log('Location changed!', location.pathname);
  //   };
  // }, []);

  return (
    <MainLayout>
      <Helmet>
        <title>Checkout</title>
      </Helmet>
      <Checkout />
    </MainLayout>
  );
};

export default CheckoutPage;
